var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Serializer } from './Serializer';
var KeyValueStorage = /** @class */ (function () {
    function KeyValueStorage() {
        this.database = null;
        this.tableName = '_ionickv';
        this.databaseName = '_ionicstorage';
        this.localStorageKeyPrefix = this.tableName + "__";
        var sqliteAvailable = !!window.sqlitePlugin;
        this.create = sqliteAvailable ? this.sqliteCreate : this.localStorageCreate;
        this.get = sqliteAvailable ? this.sqliteGet : this.localStorageGet;
        this.set = sqliteAvailable ? this.sqliteSet : this.localStorageSet;
        this.remove = sqliteAvailable ? this.sqliteRemove : this.localStorageRemove;
        this.clear = sqliteAvailable ? this.sqliteClear : this.localStorageClear;
        this.length = sqliteAvailable ? this.sqliteLength : this.localStorageLength;
        this.keys = sqliteAvailable ? this.sqliteKeys : this.localStorageKeys;
        this.forEach = sqliteAvailable ? this.sqliteForEach : this.localStorageForEach;
        this.destroyStorage = sqliteAvailable ? this.sqliteDestroyStorage : this.localStorageDestroyStorage;
    }
    KeyValueStorage.prototype.sqliteCreate = function (encryptionKey) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    KeyValueStorage.prototype.localStorageCreate = function (encryptionKey) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.database === null) {
                    this.database = localStorage;
                    console.log('db initialized');
                    console.warn('KeyValueStorage is using LocalStorage as a fallback in web and does not use encryption in this state. This is meant for development purposes only!');
                }
                return [2 /*return*/];
            });
        });
    };
    KeyValueStorage.prototype.sqliteSet = function (key, value) {
        return __awaiter(this, void 0, void 0, function () {
            var _value;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.assertSqliteDb();
                        return [4 /*yield*/, Serializer.serialize(value)];
                    case 1:
                        _value = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                _this.database.transaction(function (tx) { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        tx.executeSql("INSERT OR REPLACE INTO " + this.tableName + " (key, value) VALUES (?, ?)", [key, _value], function () {
                                            resolve(value);
                                        }, function (error) {
                                            reject(error);
                                        });
                                        return [2 /*return*/];
                                    });
                                }); });
                            })];
                }
            });
        });
    };
    KeyValueStorage.prototype.localStorageSet = function (key, value) {
        return __awaiter(this, void 0, void 0, function () {
            var _value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Serializer.serialize(value)];
                    case 1:
                        _value = _a.sent();
                        localStorage.setItem(this.localStorageKeyPrefix + key, _value);
                        return [2 /*return*/, value];
                }
            });
        });
    };
    KeyValueStorage.prototype.sqliteGet = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.assertSqliteDb();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.database.transaction(function (tx) {
                            tx.executeSql("SELECT * FROM " + _this.tableName + " WHERE key = ? LIMIT 1", [key], function (t, result) {
                                var res = result.rows.length === 1 ? result.rows.item(0).value : null;
                                if (res !== null) {
                                    res = Serializer.deserialize(res);
                                }
                                resolve(res);
                            }, function (error) {
                                reject(error);
                            });
                        });
                    })];
            });
        });
    };
    KeyValueStorage.prototype.localStorageGet = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var data, res;
            return __generator(this, function (_a) {
                data = localStorage.getItem(this.localStorageKeyPrefix + key);
                res = data !== null ? data : null;
                if (res !== null) {
                    res = Serializer.deserialize(res);
                }
                return [2 /*return*/, res];
            });
        });
    };
    KeyValueStorage.prototype.sqliteRemove = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.assertSqliteDb();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.database.transaction(function (tx) {
                            tx.executeSql("DELETE FROM " + _this.tableName + " WHERE key = ?", [key], function () {
                                resolve();
                            }, function (error) {
                                reject(error);
                            });
                        });
                    })];
            });
        });
    };
    KeyValueStorage.prototype.localStorageRemove = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, localStorage.removeItem(this.localStorageKeyPrefix + key)];
            });
        });
    };
    KeyValueStorage.prototype.sqliteClear = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.assertSqliteDb();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.database.transaction(function (tx) {
                            tx.executeSql("DELETE FROM " + _this.tableName, [], function () {
                                resolve();
                            }, function (error) {
                                reject(error);
                            });
                        });
                    })];
            });
        });
    };
    KeyValueStorage.prototype.localStorageClear = function () {
        return __awaiter(this, void 0, void 0, function () {
            var keys, _i, keys_1, key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorageKeys()];
                    case 1:
                        keys = _a.sent();
                        _i = 0, keys_1 = keys;
                        _a.label = 2;
                    case 2:
                        if (!(_i < keys_1.length)) return [3 /*break*/, 5];
                        key = keys_1[_i];
                        return [4 /*yield*/, this.localStorageRemove(key)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    KeyValueStorage.prototype.sqliteLength = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.assertSqliteDb();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.database.transaction(function (tx) {
                            tx.executeSql("SELECT COUNT(key) as c FROM " + _this.tableName, [], function (t, result) {
                                resolve(result.rows.item(0).c);
                            }, function (error) {
                                reject(error);
                            });
                        });
                    })];
            });
        });
    };
    KeyValueStorage.prototype.localStorageLength = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, localStorage.length];
            });
        });
    };
    KeyValueStorage.prototype.sqliteKeys = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.assertSqliteDb();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.database.transaction(function (tx) {
                            tx.executeSql("SELECT key FROM " + _this.tableName, [], function (t, result) {
                                var keys = [];
                                for (var i = 0; i < result.rows.length; i++) {
                                    keys.push(result.rows.item(i).key);
                                }
                                resolve(keys);
                            }, function (error) {
                                reject(error);
                            });
                        });
                    })];
            });
        });
    };
    KeyValueStorage.prototype.localStorageKeys = function () {
        return __awaiter(this, void 0, void 0, function () {
            var length, keys, i, rawKey;
            return __generator(this, function (_a) {
                length = localStorage.length;
                keys = [];
                for (i = 0; i < length; i++) {
                    rawKey = localStorage.key(i);
                    if (rawKey && rawKey.startsWith(this.localStorageKeyPrefix)) {
                        keys.push(rawKey.replace(this.localStorageKeyPrefix, ''));
                    }
                }
                return [2 /*return*/, keys];
            });
        });
    };
    KeyValueStorage.prototype.sqliteForEach = function (fn) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.assertSqliteDb();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.database.transaction(function (tx) {
                            tx.executeSql("SELECT * FROM " + _this.tableName, [], function (t, result) {
                                var rows = result.rows;
                                for (var i = 0; i < rows.length; i++) {
                                    var item = rows.item(i);
                                    var _value = item.value !== null ? item.value : null;
                                    if (_value !== null) {
                                        _value = Serializer.deserialize(_value);
                                    }
                                    fn(item.key, _value, i + 1);
                                }
                                resolve();
                            }, function (error) {
                                reject(error);
                            });
                        });
                    })];
            });
        });
    };
    KeyValueStorage.prototype.localStorageForEach = function (fn) {
        return __awaiter(this, void 0, void 0, function () {
            var keys, i, _a, key, value, index;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.localStorageKeys()];
                    case 1:
                        keys = _b.sent();
                        i = 0;
                        _b.label = 2;
                    case 2:
                        _a = i;
                        return [4 /*yield*/, keys];
                    case 3:
                        if (!(_a < (_b.sent()).length)) return [3 /*break*/, 6];
                        key = keys[i];
                        return [4 /*yield*/, this.localStorageGet(key)];
                    case 4:
                        value = _b.sent();
                        index = i + 1;
                        fn(key, value, index);
                        _b.label = 5;
                    case 5:
                        i++;
                        return [3 /*break*/, 2];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    KeyValueStorage.prototype.sqliteDestroyStorage = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    KeyValueStorage.prototype.localStorageDestroyStorage = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.localStorageClear()];
                    case 1:
                        _a.sent();
                        this.database = null;
                        return [2 /*return*/];
                }
            });
        });
    };
    KeyValueStorage.prototype.assertSqliteDb = function () {
        if (this.database === null) {
            throw new Error('The database has not been initialized. Please run create() before other calls.');
        }
    };
    return KeyValueStorage;
}());
export { KeyValueStorage };
